import { type PublicClip } from '@air/api';
import { type AssetCustomFieldValue, type BaseCustomField, type Clip } from '@air/api/types';
import { type GallerySection } from '@air/component-gallery-view';

import { type GalleryMetadata } from '~/components/Gallery/galleryMetadata';
import { type ConfigViewOption } from '~/store/configViews/types';

export const getAssetCustomFields = ({
  visibleCustomFields,
  allCustomFields,
  clip,
}: {
  clip: Pick<Clip | PublicClip, 'customFields' | 'assetId'>;
  visibleCustomFields: ConfigViewOption[];
  allCustomFields: BaseCustomField[];
}) =>
  visibleCustomFields.reduce<AssetCustomFieldValue[]>((cfs, visibleCF) => {
    const customField = allCustomFields?.find((cf) => cf.id === visibleCF.customFieldId);
    if (customField) {
      const cf = clip.customFields?.find((cf) => cf.id === visibleCF.customFieldId) || {
        ...customField,
        assetId: clip.assetId,
        value: null,
        values: null,
      };
      return [...cfs, cf];
    }
    return cfs;
  }, []);

export const EMPTY_SECTION_PRESERVE_GAP_HEIGHT = 16;
export const EMPTY_SECTION_HEADER_HEIGHT = 0;

export const modifySectionHeaderToEmpty = ({
  section,
  showHeader,
  isFirstSection,
}: {
  section: GallerySection<GalleryMetadata> | null;
  showHeader: boolean;
  isFirstSection: boolean;
}) =>
  section
    ? {
        ...section,
        ...(showHeader === false && {
          header: {
            ...section.header,
            box: {
              ...section.header?.box,
              height: isFirstSection ? EMPTY_SECTION_PRESERVE_GAP_HEIGHT : EMPTY_SECTION_HEADER_HEIGHT,
            },
            render: () => null,
          },
        }),
      }
    : null;
